export default "__VITE_ASSET__BBbrQCPS__"